// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lXYkD","content":"styles_content__1kBTq","tableWrap":"styles_tableWrap__3Kq-R"};